module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(!_vm.actionData.emails.sendMail) ? _c('el-alert', {
    attrs: {
      "type": "info",
      "title": 'This ' + _vm.actionData.actionType + ' won\'t send e-mails',
      "description": "",
      "show-icon": "",
      "closable": false
    }
  }, [_vm._v("\n            In the email settings, send email has been disabled. A manager level user can turn it on. \n            "), (_vm.isTowerCo() && _vm.isManager()) ? _c('el-switch', {
    model: {
      value: (_vm.actionData.emails.sendMail),
      callback: function($$v) {
        _vm.$set(_vm.actionData.emails, "sendMail", $$v)
      },
      expression: "actionData.emails.sendMail"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('h4', {
    class: _vm.titleColour()
  }, [_c('small', [_c('i', {
    class: _vm.actionData.workflow.icon
  }), _vm._v(" " + _vm._s(_vm.actionData.workflow.name) + ":")]), _vm._v("\n               " + _vm._s(_vm.actionData.site.siteName) + "\n            ")]), _vm._v(" "), (_vm.actionData.organisation.colourCode && _vm.actionData.organisation.shortName) ? _c('span', [_c('org-badge', {
    staticClass: "pull-right",
    attrs: {
      "organisation": _vm.actionData.organisation
    }
  })], 1) : _c('div', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("by: "), _c('b', [_vm._v(_vm._s(_vm.actionData.organisation.name))])])])])])], 1), _vm._v(" "), _c('el-row', [(_vm.isTablet || _vm.isDesktop) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.activeStep - 1,
      "finish-status": "success",
      "align-center": "",
      "direction": !(_vm.isTablet || _vm.isDesktop) ? 'vertical' : 'horizontal'
    }
  }, _vm._l((_vm.steps), function(s) {
    return _c('el-step', {
      key: s.title,
      attrs: {
        "description": s.title
      }
    }, [_c('template', {
      slot: "icon"
    }, [_c('i', {
      class: s.icon,
      staticStyle: {
        "background": "inherit"
      }
    })])], 2)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, _vm._l((_vm.actionData.parties), function(partyNo) {
    return _c('el-tab-pane', {
      key: partyNo,
      attrs: {
        "label": _vm.partyName(partyNo),
        "lazy": ""
      }
    }, [_c('el-tabs', {
      model: {
        value: (_vm.selectedFileTab),
        callback: function($$v) {
          _vm.selectedFileTab = $$v
        },
        expression: "selectedFileTab"
      }
    }, _vm._l((_vm.steps), function(s, ind) {
      return _c('el-tab-pane', {
        key: s.id,
        attrs: {
          "name": 'fileStep' + Number(ind + 1),
          "disabled": _vm.activeStep < Number(ind + 1),
          "lazy": ""
        }
      }, [_c('template', {
        slot: "label"
      }, [_c('i', {
        class: s.icon
      }, [_vm._v(" ")]), (_vm.isDesktop) ? _c('span', [_vm._v(_vm._s(s.title))]) : _vm._e()]), _vm._v(" "), _c('files-table', {
        attrs: {
          "title": s.title + (!_vm.partyOrg(partyNo) ? ': ' + _vm.partyName(partyNo) : ''),
          "id": _vm.getFileTableRef(partyNo),
          "name": _vm.getFileTableRef(partyNo),
          "table-ref": 'filestable' + partyNo,
          "org-badge": _vm.partyOrg(partyNo),
          "site-id": _vm.actionData.site_id,
          "type": _vm.actionData.actionType.toLowerCase(),
          "type-id": _vm.actionData.id,
          "step": ind + 1,
          "partyNo": partyNo,
          "step-data": _vm.step,
          "show-refresh": "",
          "show-search": false,
          "disable-form": !_vm.isActive(_vm.actionData),
          "size": "small",
          "upload-info": _vm.requestsInfo,
          "upload-callback": _vm.afterUpload
        }
      })], 2)
    }), 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "map"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_vm._v("Map "), _c('i', {
    staticClass: "header-icon fa fa-map-marker"
  })])]), _vm._v(" "), _c('site-map', {
    attrs: {
      "row-data": _vm.actionData
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "workflow"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_vm._v("Workflow "), _c('i', {
    staticClass: "header-icon fa fa-ellipsis-h"
  })])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "offset": 1,
      "span": 21
    }
  }, [_c('center', [(_vm.steps[_vm.activeStep - 1]) ? _c('h4', [_c('i', {
    class: _vm.steps[_vm.activeStep - 1].icon
  }), _vm._v(" " + _vm._s(_vm.steps[_vm.activeStep - 1].title))]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("| Step " + _vm._s(_vm.activeStep) + " of " + _vm._s(_vm.steps.length))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.state
    }
  }, [_c(_vm.comp, {
    tag: "component",
    attrs: {
      "row-data": _vm.rowData,
      "row-index": _vm.rowIndex,
      "step-data": _vm.step,
      "read-only": _vm.readOnly
    },
    on: {
      "updated": _vm.stepUpdated
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-row', [(_vm.activeStep > 1) ? _c('el-col', {
    attrs: {
      "span": 4,
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.prevStep()
      }
    }
  }, [_vm._v("< Previous Step")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "push": _vm.activeStep > 1 ? 4 : 8,
      "align": "center"
    }
  }, [_c('el-alert', {
    attrs: {
      "show-icon": "",
      "type": _vm.step.completed ? 'success' : 'warning',
      "center": "",
      "closable": false
    }
  }, [(_vm.isTowerCo() && _vm.isManager()) ? _c('check-box', {
    attrs: {
      "no-form": "",
      "disabled": _vm.step.approved && _vm.step.completed
    },
    on: {
      "change": _vm.completeStep
    },
    model: {
      value: (_vm.step.completed),
      callback: function($$v) {
        _vm.$set(_vm.step, "completed", $$v)
      },
      expression: "step.completed"
    }
  }, [_vm._v("Complete Step")]) : _vm._e(), _vm._v("\n                        "), (_vm.step.completed) ? _c('span', [_vm._v("on "), _c('b', [_vm._v(_vm._s(_vm.formatDateTime(_vm.step.completed_at)))]), _vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.step.completed_by))])]) : _c('span', [_vm._v("Step Pending Approval")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": (_vm.activeStep > 1 ? 12 : 16),
      "pull": 1,
      "align": "right"
    }
  }, [(_vm.activeStep <= _vm.steps.length) ? _c('el-button', {
    attrs: {
      "type": "info",
      "disabled": !_vm.validateStep(_vm.activeStep)
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("Finish Step "), _c('b', [_vm._v(_vm._s(_vm.activeStep))]), _vm._v(" / " + _vm._s(_vm.steps.length))]) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.activeStep === _vm.steps.length && _vm.step.approved) ? _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.validateStep(_vm.activeStep)
    },
    on: {
      "click": function($event) {
        return _vm.completeWorkflow()
      }
    }
  }, [_vm._v("Complete " + _vm._s(_vm.actionData.actionType))]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.actionData.actionType) + " # "), _c('b', [_vm._v(_vm._s(_vm.actionData.id) + "-" + _vm._s(_vm.step.partyNo) + "-" + _vm._s(_vm.step.stepNo) + "/" + _vm._s(_vm.step.id))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20,
      "align": "right"
    }
  }, [_c('div', [_c('popup', {
    attrs: {
      "heading": "Configure Emails",
      "button-text": _vm.configNeeded ? 'Emails Setup' : 'Emails Update',
      "button-style": _vm.configNeeded ? 'danger' : 'text',
      "show-save": false,
      "center-button": true,
      "button-icon": "fa fa-envelope"
    }
  }, [_c('email-setup', {
    attrs: {
      "row-data": _vm.actionData,
      "rtx-info": _vm.rtxInfo
    }
  })], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28edf238"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/workflow/RequestWorkflow.vue
// module id = 1384
// module chunks = 0